module.exports = __webpack_public_path__ + "media/images/badge/nerd-7922702c46de8865c917c9ec8ef82af3.png";